// ============================================================
// SHARED PRIMITIVES
//
// Small, dependency-free helpers used by every transform file
// in this folder (both forward - frontend -> backend - and
// reverse - backend -> frontend).
// ============================================================

export const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

export const cleanString = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).trim();
};

export const numberOrNull = (value) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : null;
};

export const booleanValue = (value, fallback = false) => {
    if (value === undefined || value === null) {
        return fallback;
    }

    if (typeof value === 'boolean') {
        return value;
    }

    return value === true || value === 'true';
};

export const arrayOrEmpty = (value) => {
    return Array.isArray(value) ? value : [];
};

export const stringArray = (value) => {
    return arrayOrEmpty(value)
        .map((item) => {
            if (typeof item === 'string') {
                return item.trim();
            }

            if (isObject(item)) {
                return cleanString(item.name || item.label || item.value || item.title);
            }

            return '';
        })
        .filter(Boolean);
};

/*
 * Flattens either:
 *
 * - a flat array of items, or
 * - an object grouping items by category, e.g.
 *   { food: [...], transport: [...] }
 *
 * into one flat array. Used both by services (grouped by
 * category in the UI) and unit amenities (grouped by category
 * on the backend).
 */
export const flattenGrouped = (value) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (isObject(value)) {
        return Object.values(value)
            .filter(Array.isArray)
            .flat();
    }

    return [];
};

/* ============================================================
   SLUG
============================================================ */

export function createSlug(title = '') {
    return cleanString(title)
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}
